import HTTP from './common/http-common';

const END_POINT = '/page-group';

const listPageGroup = () => HTTP.get(END_POINT, { cache: false });
const listAvaliablePageGroup = () => HTTP.get(END_POINT + "/group/active", { cache: false });
const listPageByGroup = (groupCode) => HTTP.get(END_POINT + "/page/" + groupCode, { cache: false });
const insert = (data) => HTTP.post(END_POINT, {
    groupCode: data.groupCode,
    pages: data.pages
});
const update = (data) => HTTP.post(END_POINT + "/" + data.groupCode, {
    pages: data.pages
});

const deletePageGroup = (pageGroupId) => HTTP.delete(END_POINT + "/" + pageGroupId);

export {
    listPageGroup,
    listAvaliablePageGroup,
    listPageByGroup,
    insert,
    update,
    deletePageGroup
}